import { render, staticRenderFns } from "./InsLogoGather.vue?vue&type=template&id=66f20dea&scoped=true"
import script from "./InsLogoGather.vue?vue&type=script&lang=ts"
export * from "./InsLogoGather.vue?vue&type=script&lang=ts"
import style0 from "./InsLogoGather.vue?vue&type=style&index=0&id=66f20dea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f20dea",
  null
  
)

export default component.exports